import styled, { css } from "styled-components";
import AntRate from "antd/es/rate";

export const inactiveStarBackground = (darkModeBgColor?: string) => css`
  .ant-rate-star-zero,
  .ant-rate-star-half,
  .ant-rate-star-focused:not(.ant-rate-star-full) {
    .ant-rate-star-second {
      color: ${(p) =>
        p.theme.isDarkMode ? darkModeBgColor : "rgba(0, 0, 0, 0.1)"};
    }
  }
`;

const Rate = styled(AntRate)`
  color: inherit;
  .ant-rate-star-full,
  .ant-rate-star-half {
    color: ${(p) => p.theme.colors.primaryBlue};
  }
  .ant-rate-star:not(:last-child) {
    margin-right: 4px;
  }
  ${inactiveStarBackground("rgba(118,140,184,0.25)")};
`;

export default Rate;
